import {
  DISPLAY_TOURNAMENTS,
  START_LOADING_TOURNAMENTS,
  SET_SEARCH_TOURNAMENT_VALUE_FOR_TOURNAMENTS,
  UPDATE_SHOW_ALL_TOURNAMENTS,
  SET_CAN_CREATE_TOURNAMENTS,
  DISPLAY_GROUP_NAME
} from './constants';

export const displayTournaments = data => ({
  type: DISPLAY_TOURNAMENTS,
  payload: { entries: data }
});

export const setSearchTournamentValue = searchValue => ({
  type: SET_SEARCH_TOURNAMENT_VALUE_FOR_TOURNAMENTS,
  payload: { searchValue: searchValue }
});

export const startLoadingTournaments = () => ({
  type: START_LOADING_TOURNAMENTS,
  payload: { }
});

export const updateShowAllTournaments = showAllTournaments => ({
  type: UPDATE_SHOW_ALL_TOURNAMENTS,
  payload: showAllTournaments
});

export const setCanCreateTournaments = canCreateTournaments => ({
  type: SET_CAN_CREATE_TOURNAMENTS,
  payload: canCreateTournaments
});

export const displayGroupName = data => ({
  type: DISPLAY_GROUP_NAME,
  payload: data
});


// WEBPACK FOOTER //
// ./src/features/tournament/tournamentList/actionTypes.js